<template>
	<div>
		<Modal :onClose="onClose">
			<div slot="header">New Ads</div>
			<form v-on:submit.prevent="onSubmitAds">
				<div class="form-error" v-if="statusMessage.error">
					<div class="alert alert-danger" role="alert">
					  <span>Sorry, Ads can't be created</span>
					  <ul>
					  	<li v-for="(error, index) in statusMessage.error" :key="index">{{error}}</li>
					  </ul>
					</div>
				</div>
				<div class="form-detail">
					<div class="row">
						<div class="col-md-12">
							<form-group :error="getError(error, 'name')">
								<label for="name">Name</label>
								<input type="text" class="form-control" placeholder="Name" v-model="ads.name" autofocus required />
							</form-group>
						</div>
						<div class="col-md-12">
							<form-group :error="getError(error, 'adsTagUrl')">
								<label for="name">Ads Tag</label>
								<textarea class="form-control" rows="3" v-model="ads.adsTagUrl" required></textarea>
							</form-group>
						</div>
					</div>
				</div>
				<div class="form-actions">
					<div class="row">
						<div class="col-md-12">
							<button type="submit" class="btn btn-success btn-block" :disabled="!isValid">Create</button>
						</div>
					</div>
				</div>
			</form>
		</Modal>
	</div>
</template>

<script>
import { getError } from '@/modules/utilities';
import Modal from '@/components/elements/Modal';
import FormGroup from '@/components/elements/FormGroup';

export default {
	props: ['onClose', 'onSubmit', 'statusMessage'],
	components: {
		Modal,
		FormGroup,
	},
	data() {
		return {
			ads: {
				name: null,
				adsTagUrl: null,
			},
		};
	},
	computed: {
		isValid() {
			return this.ads.name && this.ads.adsTagUrl;
		},
		error() {
			return this.statusMessage.error;
		},
	},
	methods: {
		getError,
		onSubmitAds() {
			this.onSubmit(this.ads);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/themes/variables.scss';
</style>



// WEBPACK FOOTER //
// src/components/parts/ads-preset/CreateAdsModal.vue